// ** Styles
import { useState, useCallback, useEffect } from 'react';
import '@styles/react/apps/app-roads.scss';
import { useParams } from 'react-router-dom';
import Wizard from '../shared/Wizard';
import { GetEpisodeById } from '../../../../graphql/Mutation';
import { useMutation } from '@apollo/client';

const FIELDS = [
  'title',
  'description',
  'status',
  'activity',
  'cover',
  'frases',
  'contents',
  'tags',
  'pillars',
  'gender'
];

const EditEpisode = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [getEpisodeById] = useMutation(GetEpisodeById);

  const formatData = (data) => {
    const formatedData = {};
    FIELDS.map((key) => {
      formatedData[key] = data[key];
    });

    setValues({
      ...formatedData,
      pillars: undefined,
      ...formatedData.pillars,
      __typename: undefined
    });
  };

  const handleFetch = useCallback(async () => {
    try {
      const {
        data: { getEpisodeById: data }
      } = await getEpisodeById({ variables: { episodeId: id } });

      formatData(data);
      setLoading(false);
    } catch (e) {}
  }, []);

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  return !loading ? (
    <Wizard editMode={true} defaultValues={values} episodeId={id} />
  ) : null;
};

export default EditEpisode;
